/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-cycle */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
// import { AiOutlineMenu } from 'react-icons/ai';
// import { RiNotification3Line } from 'react-icons/ri';
import { MdKeyboardArrowDown, MdHelpOutline } from 'react-icons/md';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import axios from 'axios';
import { isMobile } from 'react-device-detect';
import { Notification, UserProfile, UserFAQ } from '.';
import { useStateContext } from '../contexts/ContextProvider';
import { Methods } from '../pages';

const NavButton = ({ title, customFunc, icon, color, dotColor, badge }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ color }}
      className="relative text-xl rounded-full p-3 hover:bg-light-gray"
    >
      <span
        style={{ background: dotColor }}
        className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
      />
      {icon}
    </button>
  </TooltipComponent>
);
const NavBadgeButton = ({ title, customFunc, icon, color, dotColor, badge }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ color }}
      className="relative text-xl mt-2 rounded-full p-3 hover:bg-light-gray"
    >
      <span
        style={{ background: dotColor }}
        className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
      />
      {/* Notification Badge */}
      <div className="margin fontSize">{icon}</div>
      <div className="badge-block">
        {/* Warning Colored Notification Badge */}
        <span className="e-badge e-badge-warning e-badge-notification e-badge-overlap">{badge}</span>
      </div>
    </button>
  </TooltipComponent>
);
export const orgData = [];

const Navbar = () => {
  const {
    currentColor,
    activeMenu,
    setActiveMenu,
    handleClick,
    isClicked,
    setScreenSize,
    screenSize,
    setIsMobile,
    setZRenderMode,
    setParentOrgs,
    setAIType,
    setIdleLogout,
    reloadCounts,
    setReloadCounts,
  } = useStateContext();
  let orgObj;
  let selectedOrg = JSON.parse(localStorage.getItem('organization'));
  if (!selectedOrg) {
    selectedOrg = { id: 'na', name: 'Select Parent Organization' };
    localStorage.setItem('organization', JSON.stringify(selectedOrg));
  }

  const [text, setText] = useState();
  const [value, setValue] = useState();
  const [badge, setBadge] = useState('0');
  const [reload, setReload] = useState(new Date());
  // RE-RENDER const [fetch, setFetch] = useState(false);
  const { loading, data } = Methods('user', 'GET', '') || {};
  const usr = JSON.parse(localStorage.getItem('user'));
  const { REACT_APP_API_ENDPOINT } = process.env;
  // RE-RENDER const timerid = useRef();
  useEffect(() => {
    setParentOrgs(data.organization);
  }, [data]);
  useEffect(() => {
    if (data && data.user && data.user.idleLogout && data.user.idleLogout.length > 0) {
      setIdleLogout(data.user.idleLogout);
    }
  }, [data]);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
      if (window.innerWidth < 768) {
        setIsMobile(isMobile);
        setZRenderMode('Vertical');
      } else {
        setIsMobile(isMobile);
        setZRenderMode('Horizontal');
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    const getData = async () => {
      usr.limit = 100;
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const uri = `${REACT_APP_API_ENDPOINT}/notifications?${query}`;
      await axios({
        url: uri,
        method: 'GET',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if (response && response.data && response.data.notifications && response.data.notifications.length >= 100) {
          setBadge('99+');
        } else if (response && response.data && response.data.notifications && response.data.notifications.length >= 1) {
          setBadge(response.data.notifications.length);
        } else {
          setBadge(0);
        }
        setReloadCounts(reloadCounts + 1);
      })
        .catch((error) => {
          console.error(error);
        });
    };
    getData();
  }, [loading, badge, reload]);
  // This will run one time after the component mounts
  function fetchAlerts() {
    setReload(new Date());
  }
  /*
  RE-RENDER
  useEffect(() => {
    // callback function to call when event triggers
    if (!timerid.current) {
      timerid.current = setInterval(fetchAlerts, 60000);
    }
    // return () => {
    //  console.log('useEffect navbar clearInterval');
    // timerid.current = clearInterval(timerid.current);
    // };
  }, [badge]);
  */
  useEffect(() => {
    if (screenSize <= 900) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize]);
  // 2. Value Template for selected item (placeholder area)
  const vTemplate = (props) => (
    <div>
      <span className={props.iconCss} style={{ marginRight: '8px' }} />
      <span>{props.text}</span>
    </div>
  );

  // 3. Item Template for dropdown list
  const iTemplate = (props) => (
    <div>
      <span className={props.iconCss} style={{ marginRight: '8px' }} />
      <span>{props.text}</span>
    </div>
  );

  const handleActiveMenu = () => {
    setActiveMenu(!activeMenu);
  };
  if (loading) {
    return;
  }
  // call the change event's function after initialized the component.
  let oitem = 'null';
  let otext = 'null';
  if (data && data.organization && data.organization.length > 0) {
    oitem = data.organization[0]._id;
    otext = data.organization[0].title;
  }
  function change(args) {
    setValue(args.itemData === null ? oitem : args.itemData.id);
    setText(args.itemData === null ? otext : args.itemData.text);
    localStorage.setItem('organization', JSON.stringify({
      id: args.itemData.id,
      name: args.itemData.text,
    }));
    window.location.reload();
  }
  orgData.push({ id: 'na',
    text: 'Select Parent Organization',
    iconCss: 'e-icons e-filter' });
  if (data && data.organization) {
    data.organization.forEach((org) => {
    // if (org.children) {
      orgData.push({ id: org._id, text: org.title, iconCss: 'e-icons e-chevron-right-fill-2' });
    // }
    });
  }

  return (
    <div
      className={!isMobile ? 'flex justify-between p-2 md:ml-6 md:mr-6 relative' : ''}
      style={{ position: !isMobile ? 'relative' : '', zIndex: '2000' }}
    >
      <NavButton title="Menu" customFunc={handleActiveMenu} icon={<img src="./hamburger.png" alt="Menu" width="60px" />} />
      <div className="flex">
        <DropDownListComponent
          id="orgsel"
          ref={(orgs) => { orgObj = orgs; }}
          dataSource={orgData}
          fields={orgData}
          change={change}
          value={selectedOrg ? selectedOrg.name : 'na'}
          placeholder="Select an Organization"
          valueTemplate={vTemplate}
          itemTemplate={iTemplate}
        />
        <NavBadgeButton
          title="Notification"
          customFunc={() => handleClick('notification')}
          color={currentColor}
          badge={badge}
          icon={<img src="./greenbell.png" alt="notifications" width="60px" />}
        />
        <TooltipComponent content="Profile" position="BottomCenter">
          <div
            className="flex items-center gap-2 cursor-pointer p-1 hover:bg-light-gray rounded-lg"
            onClick={() => handleClick('userProfile')}
          >
            <img
              className="rounded-full w-8 h-8"
              src={data && data.user && data.user.image ? data.user.image : null}
              alt="user-profile"
            />
            <p>
              <span className="e-icons e-calculated-member" />
              <span className="text-gray-400 text-14">Hi,</span>{' '}
              <span className="text-gray-400 font-bold ml-1 text-14">
                {data.user.first}
              </span>
            </p>
            <MdKeyboardArrowDown className="text-gray-400 text-14" />
          </div>
        </TooltipComponent>
        <TooltipComponent content="FAQ" position="BottomCenter">
          <div
            className="flex items-center gap-2 cursor-pointer p-1 hover:bg-light-gray rounded-lg zackat-divalh"
            onClick={() => { setAIType('Knowledge Base'); handleClick('userFaq'); }}
          >
            <p>
              <span className="text-gray-400 text-14">FAQ</span>{' '}
            </p>
            <MdHelpOutline className="text-gray-400 text-14" />
          </div>
        </TooltipComponent>
        {isClicked.notification && (<Notification />)}
        {isClicked.userProfile && (<UserProfile />)}
        {isClicked.userFaq && (<UserFAQ dt="Knowledge Base" />)}
      </div>
    </div>
  );
};

export default Navbar;

